export default __webpack_public_path__ + "static/media/banner-06.6763a94d.png";